import type { GetStaticProps, NextPage } from 'next'
import React, { useEffect } from 'react';
import Contactus from '../components/ContactUsPage';
import { MetaTagsComp } from '../components/MetaTagsComp';
import fetchUtil from '../utils/fetchUtil';

const ContactUs: NextPage = (props: any) => {
  const { meta } = props.contactusData
  useEffect(() => {
    const customStyle = document.documentElement.style
    customStyle.setProperty('--navbar-color', '#226CF5');
    customStyle.setProperty('--navbar-menu-color', '#ffffff')
  }, [])
  return (
    <>
      {meta && <MetaTagsComp {...meta} />}
      <Contactus {...props} />
    </>
  )
}

export const getStaticProps: GetStaticProps = async (context) => {
  const officeCountriesData = await fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/office-countries`, 'GET', {}, '', false)
  const contactusData = await fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/contactus`, 'GET', {}, '', false)
  return {
    props: {
      officeCountriesData,
      contactusData
    }
  };
}

export default ContactUs;